import { forwardRef } from "react";
import { cn } from "../../../helpers/cn";

/**
 * @typedef {React.HTMLProps<HTMLInputElement>} InputProps
 * @typedef {React.HTMLProps<HTMLLabelElement>} LabelProps
 * @typedef {React.HTMLProps<HTMLDivElement>} HelperTextProps
 */

/**
 * @typedef {Object} CustomInputProps
 * @property {string} [label]
 * @property {boolean} [isError]
 * @property {string} [helperText]
 * @property {LabelProps} [labelProps]
 * @property {HelperTextProps} [helperTextProps]
 */

/**
 * @typedef {InputProps & CustomInputProps} ExtendedInputProps
 */

/**
 * @param {ExtendedInputProps} props
 */

function Input(
  {
    label,
    id,
    className,
    isError = false,
    required = false,
    helperText,
    labelProps = {},
    helperTextProps = {},

    ...rest
  },
  ref
) {
  const { className: labelClassName = "", ...labelRest } = labelProps;
  const { className: helperTextClassName = "", ...helperTextRest } =
    helperTextProps;

  return (
    <div className="tw-flex tw-flex-col tw-flex-1">
      {label && (
        <label
          className={cn(
            `${isError ? "tw-text-red-500 focus:tw-border-red-400" : ""}`,
            labelClassName
          )}
          htmlFor={id}
          {...labelRest}
        >
          {label} {required && <span className="tw-text-red-500">*</span>}
        </label>
      )}
      <input
        type="text"
        className={cn(
          `form-control ${
            isError ? "tw-border-red-500 focus:tw-border-red-500" : ""
          }`,
          className
        )}
        ref={ref}
        id={id}
        {...rest}
      />
      {helperText && (
        <small
          className={cn(
            `tw-mt-1 tw-m-0 ${isError ? "tw-text-red-500" : ""}`,
            helperTextClassName
          )}
          {...helperTextRest}
        >
          {helperText}
        </small>
      )}
    </div>
  );
}

export default forwardRef(Input);
